import { TriggerGroupType } from 'src/app/form-template/form-template-model';
import {
  ComparisonType,
  OperationTrackerConfig,
  SuggestionConfig,
  SuggestionType
} from '../models/workflow-assistant.model';

export const operationDataSourceKeyToOperationTrackerMap: {
  [key: string]: OperationTrackerConfig[];
} = {
  patient: [
    {
      operationName: 'UpdatePatient',
      extractDataFrom: 'updatePatient'
    },
    {
      operationName: 'GetPatient',
      extractDataFrom: 'getPatient'
    }
  ],
  assessment: [
    {
      operationName: 'CreateAssessment',
      extractDataFrom: 'createAssessment'
    },
    {
      operationName: 'UpdateAssessment',
      extractDataFrom: 'updateAssessment'
    }
  ]
};

export const workflowAssistantSuggestionsConfig: { [key: string]: SuggestionConfig[] } = {
  patient: [
    {
      typeConfig: {
        type: SuggestionType.basic,
        title: 'Add patient contact info',
        description: "Please add the patient's email or phone number"
      },
      triggerGroups: [
        {
          type: TriggerGroupType.and,
          triggers: [
            {
              dataPath: 'patient.email',
              typeConfig: {
                type: ComparisonType.isNullOrEmpty
              }
            },
            {
              dataPath: 'patient.phone',
              typeConfig: {
                type: ComparisonType.isNullOrEmpty
              }
            }
          ]
        }
      ]
    },
    {
      typeConfig: {
        type: SuggestionType.basic,
        title: 'No questionnaires completed',
        description: 'Would you like to send the patient a questionnaire?'
      },
      triggerGroups: [
        {
          type: TriggerGroupType.and,
          triggers: [
            {
              dataPath: 'patient.questionnaireRequests.items',
              typeConfig: {
                type: ComparisonType.isNullOrEmpty
              }
            }
          ]
        }
      ]
    }
  ]
};
